import React, { FC } from 'react';
import { Question, QuestionRequired } from '@ch/common/types/data';
import { Box } from '@ch/common/components/box';
import { Button } from '@ch/common/components/button';
import { IconDelete } from '@ch/common/components/icon';
import { useData } from '../use-data';
import { boxProps } from './const';
import { QuizComplexFieldBlockStyled, QuizComplexFieldText, QuizComplexFieldWrapper } from './quiz.styled';
import { Text } from '@ch/common/components/text';
import { FormInputField } from '@ch/common/components/form/input';
import { FormFile } from '@ch/common/components/form/file';
import { icon } from './quiz-field-document';
import { FormLabel } from '@ch/common/components/form/label';
import QuizTooltip from '@ch/common/components/quiz-tooltip/quiz-tooltip';
import { useQuizManualUpload } from './hooks/use-quiz-manual-dialog';

const QuizFieldManualDialog: FC<Question> = ({
  identifier,
  question,
  tooltip,
  sub_question: subQuestion,
  required,
  file,
}) => {
  const {
    handleChange,
    uploadPdf,
    isPdfUploaded,
    pregnancyFile,
    requiredIdentifier,
    handleDelete,
  } = useQuizManualUpload(identifier);

  const {
    data: {
      keywords: { fileChoose, fileRemove, uploadKey, nofileChosenText },
    },
  } = useData();

  return (
    <>
      <Box $m={[-12, 0, 0]} data={requiredIdentifier}>
        <FormLabel m={[0]}>
          {subQuestion}
          {required === QuestionRequired.YES && (
            <Text as="span" $m={[0, 0, 0, 3]} $color="error" $size="lg">
              *
            </Text>
          )}
          {tooltip && <QuizTooltip {...{ id: identifier }}>{tooltip}</QuizTooltip>}
        </FormLabel>
        <Box $display="flex" $mt={5} $mb={5}>
          <Button $size="xs" $variant="outlined" as="a" href={`/${file}`} download target="_blank">
            {question}
          </Button>
        </Box>
        <FormInputField name={requiredIdentifier} type="hidden" />
      </Box>
      {!isPdfUploaded ? (
        <Box $m={[0, 0, 15]}>
          <FormFile
            {...{
              name: identifier,
              selectButtonTitle: fileChoose,
              uploadButtonTitle: uploadKey,
              removeButtonTitle: fileRemove,
              icon,
              onChange: handleChange,
              onUpload: uploadPdf,
              multiple: false,
              nofileChosenText,
            }}
          />
        </Box>
      ) : (
        <QuizComplexFieldBlockStyled {...{ ...boxProps, $m: [0, 0, 25] }}>
          <Box $display="flex" $alignItems="center" $justifyContent="space-between" $m={[0, 0, 15]}>
            <QuizComplexFieldWrapper>
              {icon}
              <QuizComplexFieldText $size="sm" $m={[0]} title={pregnancyFile.name}>
                {pregnancyFile.name}
              </QuizComplexFieldText>
            </QuizComplexFieldWrapper>
            <Button
              $variant="icon"
              $size="ico-xs"
              $color="primary"
              type="button"
              onClick={handleDelete}
              title={fileRemove}
              $m={[0, 0, 0, 30]}
            >
              <IconDelete $size={14} />
            </Button>
          </Box>
        </QuizComplexFieldBlockStyled>
      )}
    </>
  );
};

export default QuizFieldManualDialog;
